import styled from '@emotion/styled'
import {
  HexaV2DropdownForm,
  HexaV2DropdownMenu,
} from '@honeycomb-web/react/hexa-v2'

export const StyledDropdownForm = styled(HexaV2DropdownForm)`
  &.hexa-v2-dropdown-with-search--disabled::part(base) {
    background-color: light-dark(
      rgba(239, 239, 239, 0.3),
      rgba(59, 59, 59, 0.3)
    );
  }

  &.hexa-v2-dropdown-with-search--disabled::part(placeholder) {
    color: light-dark(rgb(84, 84, 84), rgb(170, 170, 170));
  }
`

export const StyledDropdownMenu = styled(HexaV2DropdownMenu)`
  &::part(options) {
    overflow-y: auto;
    overflow-x: hidden;
  }
`
